import { OidcContext } from '@britishcouncil/react-oidc-auth';
import { LinkButton } from '@britishcouncil/react-solas-ors3';

export const LogInBtn = () => {
  const userManager = OidcContext.useAuth();
  const handleLoginClick = () => {
    userManager!.signinRedirect();
  };
  return <LinkButton onClick={handleLoginClick}>Log In</LinkButton>;
};
